import { render, staticRenderFns } from "./InstrumentDocumentsModal.vue?vue&type=template&id=1f127cfe&scoped=true"
import script from "./InstrumentDocumentsModal.vue?vue&type=script&lang=js"
export * from "./InstrumentDocumentsModal.vue?vue&type=script&lang=js"
import style0 from "./InstrumentDocumentsModal.vue?vue&type=style&index=0&id=1f127cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f127cfe",
  null
  
)

export default component.exports